import { render, staticRenderFns } from "./english-big-start-effect-evaluation.vue?vue&type=template&id=c0d4191e&"
import script from "./english-big-start-effect-evaluation.vue?vue&type=script&lang=js&"
export * from "./english-big-start-effect-evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports